module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qualification"
  }, [_c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Education")]), _vm._v(" "), _c('ul', {
    staticClass: "education clearfix"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Highest Level of Education*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.educational_attainment),
      callback: function($$v) {
        _vm.basic_info.educational_attainment = $$v
      },
      expression: "basic_info.educational_attainment"
    }
  }, _vm._l((_vm.data_config.educational_attainment), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp1),
      expression: "!f_state.inp1"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input_info marginR"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("School Name*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "remote-method": _vm.schoolSearch,
      "loading": _vm.schoolNameSearchLanding,
      "filterable": "",
      "remote": "",
      "placeholder": "Please Search School Name *"
    },
    model: {
      value: (_vm.basic_info.school_name),
      callback: function($$v) {
        _vm.basic_info.school_name = $$v
      },
      expression: "basic_info.school_name"
    }
  }, _vm._l((_vm.searchSchool), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2),
      expression: "!f_state.inp2"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Major / Specialization*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.major),
      callback: function($$v) {
        _vm.basic_info.major = $$v
      },
      expression: "basic_info.major"
    }
  }, _vm._l((_vm.data_config.majors), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp3),
      expression: "!f_state.inp3"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v(_vm._s(_vm.basic_info.teaching_certification.certification_academic.name))]), _vm._v(" "), _c('ul', {
    staticClass: "img_list clearfix"
  }, _vm._l((_vm.basic_info.teaching_certification.certification_academic.data), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.cert_url) ? _c('i', {
      staticClass: "del el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.delUpload({
            key: 'certification_academic',
            index: index
          })
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('file-upload', {
      attrs: {
        "action": _vm.action,
        "before-upload": _vm.beforeUpload,
        "uploadKey": {
          key: 'certification_academic',
          index: index
        }
      },
      on: {
        "complete": _vm.uploadComplete
      }
    }, [_c('uploadImg', {
      attrs: {
        "message": "Upload proof",
        "imageUrl": item.cert_url
      }
    })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cert_name))])], 1)
  }))])]), _vm._v(" "), _c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Teaching Experience")]), _vm._v(" "), _c('div', {
    staticClass: "education clearfix education-experience"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("What kind of experience do you have with K-12 education in the US and/or Canada?")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.teaching_experience),
      callback: function($$v) {
        _vm.basic_info.teaching_experience = $$v
      },
      expression: "basic_info.teaching_experience"
    }
  }, _vm._l((_vm.data_config.teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.basic_info.total_teaching_experience.length > 0) ? _c('ul', {
    staticClass: "education clearfix"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("In total how much teaching experience do you have?")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.total_teaching_experience),
      callback: function($$v) {
        _vm.basic_info.total_teaching_experience = $$v
      },
      expression: "basic_info.total_teaching_experience"
    }
  }, _vm._l((_vm.data_config.total_teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key.option_value,
        "value": key.option_key
      }
    })
  }))], 1)])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "education education-experience-list clearfix"
  }, _vm._l((_vm.datas.teaching_experience_list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "clearfix"
    }, [_c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Organization Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (item.organization_name),
        expression: "item.organization_name",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (item.organization_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.organization_name = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Job Title")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": item.job_title in _vm.data_config.job_title ? _vm.data_config.job_title[item.job_title] : item.job_title
      }
    })]), _vm._v(" "), _c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Time period")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "disabled": ""
      },
      model: {
        value: (item.period_teaching_experience),
        callback: function($$v) {
          item.period_teaching_experience = $$v
        },
        expression: "item.period_teaching_experience"
      }
    }, _vm._l((_vm.data_config.period_teaching_experience), function(key, val) {
      return _c('el-option', {
        key: val,
        attrs: {
          "label": key.option_value,
          "value": key.option_key
        }
      })
    }))], 1)])
  })), _vm._v(" "), _c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Teaching certificates:")]), _vm._v(" "), _c('div', {
    staticClass: "teaching-main clearfix"
  }, _vm._l((_vm.basic_info.teaching_certification), function(certification, certificationKey) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (certificationKey !== 'certification_academic'),
        expression: "certificationKey !== 'certification_academic'"
      }],
      key: certificationKey,
      staticClass: "teaching-text"
    }, [_c('h6', [_vm._v(_vm._s(certification.name) + ":")]), _vm._v(" "), _c('ul', {
      staticClass: "img_list clearfix"
    }, _vm._l((certification.data), function(item, index) {
      return _c('li', {
        key: index
      }, [(item.cert_url) ? _c('i', {
        staticClass: "del el-icon-circle-close",
        on: {
          "click": function($event) {
            _vm.delUpload({
              key: certificationKey,
              index: index
            })
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('file-upload', {
        attrs: {
          "action": _vm.action,
          "before-upload": _vm.beforeUpload,
          "uploadKey": {
            key: certificationKey,
            index: index
          }
        },
        on: {
          "complete": _vm.uploadComplete
        }
      }, [_c('uploadImg', {
        attrs: {
          "message": "Upload proof",
          "imageUrl": item.cert_url
        }
      })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cert_name))])], 1)
    }))])
  })), _vm._v(" "), _c('p', {
    staticClass: "save"
  }, [_c('a', {
    class: {
      cancel: !_vm.isCancel
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a96e40e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/personal_qa.vue
// module id = 844
// module chunks = 1